import React from "react";
import { CheckIcon, TargetIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { volumes } from "../../data/volumes";
import { MOCKUP_URL } from "../../data/checkout";
export function VolumesSection() {
  return <section className="w-full bg-cream px-4 py-16 sm:px-5 sm:py-24" data-id="element-393" data-mp="2munbk9pm8ndd">
      <div className="mx-auto max-w-5xl" data-id="element-394" data-mp="2rsym6mnqj1wn">
        <h2 className="text-center font-serif text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-395" data-mp="2rw2thswhydrj">
          What’s Inside Interceptive Orthodontics Blueprint™?
        </h2>
        <p className="mt-4 text-center text-xl font-bold text-wine" data-id="element-396" data-mp="2iumlfrt5mnqh">6 Specialized Clinical Volumes</p>
        <p className="mx-auto mt-3 max-w-2xl text-center text-lg text-muted" data-id="element-397" data-mp="2468jdj3kb3az">
          A structured collection covering early orthodontic assessment, mixed dentition, growth-related
          considerations, treatment planning, and clinical monitoring.
        </p>

        <img src={MOCKUP_URL} alt="All six volumes and five bonuses of the Interceptive Orthodontics Blueprint" className="mx-auto mt-8 w-full max-w-xl" data-id="element-398" data-mp="1z49f870002cz" />

        <div className="mt-10 space-y-6" data-id="element-399" data-mp="1akyp5pym2mty">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-navy/10 md:grid md:grid-cols-[260px_1fr]" data-id="element-400" data-mp="1ph686mya9i7n">
              <div className="bg-navy px-6 py-6 md:py-8" data-id="element-401" data-mp="wssc4cqr8vyq">
                <p className="w-fit rounded-md bg-wine px-3 py-1 text-xs font-extrabold uppercase tracking-widest text-white" data-id="element-402" data-mp="wtacnlkg9wcg">
                  Volume {v.number}
                </p>
                <h3 className="mt-3 font-serif text-2xl font-bold leading-tight text-white" data-id="element-403" data-mp="16jdiimco74s7">{v.title}</h3>
                <p className="mt-2 text-sm font-semibold text-gold" data-id="element-404" data-mp="11r3n4qssdcij">{v.subtitle}</p>
              </div>
              <div className="px-6 py-6 md:py-8" data-id="element-405" data-mp="e0q0xgwvu7vv">
                <p className="font-semibold text-navy" data-id="element-406" data-mp="93g25anlsjvd">{v.intro[0]}</p>
                <p className="mt-1 text-muted" data-id="element-407" data-mp="913np7h20rn2">{v.intro[1]}</p>
                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-navy" data-id="element-408" data-mp="yqk7e5wjvhsh">Inside, you’ll explore:</p>
                <ul className="mt-3 space-y-2" data-id="element-409" data-mp="12rdw31hth0mf">
                  {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] text-navy" data-id="element-410" data-mp="17k70fo9di6xz">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-411" data-mp="1chp00o1i39tb" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 flex gap-2.5 rounded-xl bg-wine-soft p-4 text-[15px] text-navy" data-id="element-412" data-mp="juuj213w6skl">
                  <TargetIcon className="mt-0.5 h-4 w-4 shrink-0 text-wine" aria-hidden="true" data-id="element-413" data-mp="ose8lx61irru" />
                  <span data-id="element-414" data-mp="tt1uk4fewif7">
                    <strong className="text-wine" data-id="element-415" data-mp="tq5wmg3kdtqr">The objective:</strong> {v.objective}
                  </span>
                </p>
              </div>
            </article>)}
        </div>

        <SectionCta label="Get all 6 specialized volumes" data-id="element-416" data-mp="255kwpsr2l1q3" />
      </div>
    </section>;
}